// types
import { DefaultConfigProps } from 'types/config';

// ==============================|| THEME CONSTANT ||============================== //

export const twitterColor = '#1DA1F2';
export const facebookColor = '#3b5998';
export const linkedInColor = '#0e76a8';

export const APP_DEFAULT_PATH = '/overview';
export const HORIZONTAL_MAX_ITEM = 7;
export const DRAWER_WIDTH = 300;
export const MINI_DRAWER_WIDTH = 60;

// ==============================|| URLS & KEYS ||============================== //

export const BASE_URL = import.meta.env.VITE_APP_API_URL ?? 'https://api.cityoptima.com';
export const BASE_URL_GOOGLE_APIS = import.meta.env.VITE_APP_API_URL_GOOGLEAPIS ?? '';
export const BASE_URL_MAPTILER = import.meta.env.VITE_APP_MAPTILER ?? '';
export const API_KEY_MAPTILER = import.meta.env.VITE_APP_MAPTILER_KEY ?? '';
export const MAPILLARY_TOKEN = import.meta.env.VITE_APP_MAPILLARY_TOKEN ?? '';
export const MAPILLARY_ORG_ID = import.meta.env.VITE_APP_MAPILLARY_ORG_ID ?? '145056950289750';
export const MAPILLARY_DEFAULT_LAT = Number(import.meta.env.VITE_APP_MAPILLARY_DEFAULT_LAT ?? '');
export const MAPILLARY_DEFAULT_LNG = Number(import.meta.env.VITE_APP_MAPILLARY_DEFAULT_LNG ?? '');
export const API_KEY_GOOGLE_APIS =
  import.meta.env.VITE_APP_GOOGLE_API_KEY ?? '';
export const API_KEY_maptiler = API_KEY_MAPTILER;
export const BASE_URL_maptiler = BASE_URL_MAPTILER;
export const REACT_APP_MAPILLARY_TOKEN = MAPILLARY_TOKEN;
export const API_KEY_googleapis = API_KEY_GOOGLE_APIS;

export const BASE_URL_googleapis = 'https://maps.googleapis.com';
export const REACT_APP_MAPILLARY_ORG_ID = '1450569502898750';
export const REACT_APP_MAPILLARY_DEFAULT_LAT = '50.429409';
export const REACT_APP_MAPILLARY_DEFAULT_LNG = '-104.522505';

// ==============================|| ENUMS ||============================== //

export enum SimpleLayoutType {
  SIMPLE = 'simple',
  LANDING = 'landing'
}
export enum ThemeMode {
  LIGHT = 'light',
  DARK = 'dark'
}
export enum MenuOrientation {
  VERTICAL = 'vertical',
  HORIZONTAL = 'horizontal'
}
export enum ThemeDirection {
  LTR = 'ltr',
  RTL = 'rtl'
}
export enum NavActionType {
  FUNCTION = 'function',
  LINK = 'link'
}
export enum Gender {
  MALE = 'Male',
  FEMALE = 'Female'
}
export enum DropzoneType {
  DEFAULT = 'default',
  STANDARD = 'standard'
}
export enum AuthProvider {
  JWT = 'jwt',
  FIREBASE = 'firebase',
  AUTH0 = 'auth0',
  AWS = 'aws',
  SUPABASE = 'supabase'
}

export const APP_AUTH: AuthProvider = AuthProvider.JWT;

// ==============================|| THEME CONFIG ||============================== //

const config: DefaultConfigProps = {
  fontFamily: `'Public Sans', sans-serif`,
  i18n: 'en',
  menuOrientation: MenuOrientation.VERTICAL,
  miniDrawer: false,
  container: true,
  mode: ThemeMode.LIGHT,
  presetColor: 'default',
  themeDirection: ThemeDirection.LTR
};

export default config;
